var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlrqFocusareas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    width: "720px",
    height: "250px",
    viewBox: "0 0 720 250",
    preserveAspectRatio: "xMidYMid meet",
    id: "svg_document",
    style: {
      zoom: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg_document_title"
  }, "Untitled.svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg_document_title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "svg_document_defs"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_group"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "235px",
    id: "rect1",
    strokeWidth: 0,
    width: "120px",
    y: "10px",
    fill: "#1a60b8",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text1",
    strokeWidth: "1px",
    x: "294px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "#ffffff",
    fontSize: "16px",
    y: "33px",
    transform: "",
    textAnchor: "middle"
  }, "Foundation"), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "356px",
    y: "10px",
    strokeWidth: 0,
    width: "120px",
    id: "rect2",
    fill: "#1a60b8",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text2",
    strokeWidth: "1px",
    x: "415px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "#ffffff",
    fontSize: "16px",
    y: "33px",
    transform: "",
    textAnchor: "middle"
  }, "Intermediate"), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "477px",
    y: "10px",
    strokeWidth: 0,
    width: "120px",
    id: "rect3",
    fill: "#1a60b8",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text3",
    strokeWidth: "1px",
    x: "536px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "#ffffff",
    fontSize: "16px",
    y: "32px",
    transform: "",
    textAnchor: "middle"
  }, "Advanced"), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "598px",
    y: "10px",
    strokeWidth: 0,
    width: "120px",
    id: "rect4",
    fill: "#1a60b8",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text4",
    strokeWidth: "1px",
    x: "657px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "#ffffff",
    fontSize: "16px",
    y: "32px",
    transform: "",
    textAnchor: "middle"
  }, "Specialised"), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "235px",
    y: "46px",
    strokeWidth: "0px",
    width: "120px",
    id: "rect5",
    fill: "#e6dfe6",
    transform: ""
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "477px",
    y: "46px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "356px",
    y: "46px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "598px",
    y: "46px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "235px",
    y: "82px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "477px",
    y: "82px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect10"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "356px",
    y: "82px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect11"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "598px",
    y: "82px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect12"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "235px",
    y: "118px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect13"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "477px",
    y: "118px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect14"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "356px",
    y: "118px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect15"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "598px",
    y: "118px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect16"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "235px",
    y: "154px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect17"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "477px",
    y: "154px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect18"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "356px",
    y: "154px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect19"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "598px",
    y: "154px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect20"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "4px",
    y: "46px",
    strokeWidth: 0,
    width: "230px",
    id: "rect21",
    fill: "#92d050",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text5",
    strokeWidth: "1px",
    x: "118px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "black",
    fontSize: "11px",
    y: "68px",
    transform: "",
    textAnchor: "middle"
  }, "1. Information and Data Literacy"), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "4px",
    y: "82px",
    strokeWidth: 0,
    width: "230px",
    id: "rect22",
    fill: "#7030a0",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text6",
    strokeWidth: "1px",
    x: "118px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "white",
    fontSize: "11px",
    y: "104px",
    transform: "",
    textAnchor: "middle"
  }, "2. Communication and Collaboration"), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "4px",
    y: "118px",
    strokeWidth: 0,
    width: "230px",
    fill: "#ff0066",
    transform: "",
    id: "rect23"
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text7",
    strokeWidth: "1px",
    x: "118px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "white",
    fontSize: "11px",
    y: "140px",
    transform: "",
    textAnchor: "middle"
  }, "3. Digital Content Creation"), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "235px",
    y: "190px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect24"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "477px",
    y: "190px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect25"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "356px",
    y: "190px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect26"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "598px",
    y: "190px",
    strokeWidth: "0px",
    width: "120px",
    fill: "#e6dfe6",
    transform: "",
    id: "rect27"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "4px",
    y: "154px",
    strokeWidth: 0,
    width: "230px",
    fill: "#ff6600",
    transform: "",
    id: "rect28"
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    strokeWidth: "1px",
    x: "118px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "white",
    fontSize: "11px",
    y: "176px",
    transform: "",
    textAnchor: "middle",
    id: "text8"
  }, "4. Protection and Safety"), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#1a60b8",
    height: "35px",
    x: "4px",
    y: "190px",
    strokeWidth: 0,
    width: "230px",
    fill: "#cc9900",
    transform: "",
    id: "rect29"
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    strokeWidth: "1px",
    x: "120px",
    fontWeight: "normal",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "white",
    fontSize: "11px",
    y: "212px",
    transform: "",
    textAnchor: "middle",
    id: "text9"
  }, "5. Technical Proficiency and Problem Solving"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlrqFocusareas);
export default __webpack_public_path__ + "static/media/dlrq-focusareas.1faef00b25a011e7cefdafe47a07b897.svg";
export { ForwardRef as ReactComponent };